import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
declare var $: any;
@Component({
  selector: 'app-share-modal',
  standalone: true,
  imports: [ShareButtonsModule, ShareIconsModule],
  templateUrl: './share-modal.component.html',
  styleUrl: './share-modal.component.scss'
})
export class ShareModalComponent {
  
  @Input() currentUrl: string = ''; // Input to get the dynamic URL

  @ViewChild('shareModal', { static: true }) shareModal!: ElementRef;
  
  // Function to open modal programmatically
  openModal() {
    const modalElement = this.shareModal.nativeElement;
    if (modalElement) {
      $(modalElement).modal('show');
    }
  }

  copyToClipboard(inputElement: HTMLInputElement) {
    inputElement.select();
    document.execCommand('copy');
  }

}
